import { createAction, props } from '@ngrx/store';

import { GridTypes } from '@shared/models/grid-type.model';

export const GridTypeActionTypes = {
    CHANGE_GRID_TYPE: '[grid-type] CHANGE_GRID_TYPE',
    SET_GRID_TYPE_SUCCESS: '[grid-type] SET_GRID_TYPE_SUCCESS',
    BREAK_HTML_HIDRATION: '[grid-type] BREAK_HTML_HIDRATION',
};

export const ChangeGridType = createAction(
    GridTypeActionTypes.CHANGE_GRID_TYPE,
    props<{ gridType: GridTypes }>()
);

export const SetGridTypeSuccess = createAction(
    GridTypeActionTypes.SET_GRID_TYPE_SUCCESS,
    props<{ gridTypeCategory: GridTypes; gridType: GridTypes }>()
);
